import { CircularProgress } from '@mui/material';
import { Suspense, lazy } from 'react';
import { RequirePhysicianRequestsAccess } from './RequirePhysicianRequestsAccess';

const StaffQueuePage = lazy(() => import('../features/queue/pages/StaffQueuePage'));
const StaffReviewPage = lazy(() => import('../features/review/pages/StaffReviewPage'));

/**
 * Lazy route element for the staff case-request queue. Authorization (the PhysicianRequests claim)
 * is enforced by the route-level `RequirePhysicianRequestsAccess` guard, which mounts
 * `StaffQueuePage` — and its data hooks — only for authorized users, so no content renders and no
 * queue query fires before the guard evaluates (US1, spec 121, T024).
 */
export function StaffQueueRouteElement() {
  return (
    <RequirePhysicianRequestsAccess>
      <Suspense fallback={<CircularProgress data-testid="physician-requests-suspense-fallback" />}>
        <StaffQueuePage />
      </Suspense>
    </RequirePhysicianRequestsAccess>
  );
}

/**
 * Lazy route element for the staff case-request review page. Same `RequirePhysicianRequestsAccess`
 * guard as the queue route — no partial rendering and no review query firing before the guard
 * evaluates.
 */
export function StaffReviewRouteElement() {
  return (
    <RequirePhysicianRequestsAccess>
      <Suspense fallback={<CircularProgress data-testid="physician-requests-suspense-fallback" />}>
        <StaffReviewPage />
      </Suspense>
    </RequirePhysicianRequestsAccess>
  );
}
